module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-backplates.e8057b49.png";